module.exports = __webpack_public_path__ + "img/Logo.9181ff12.png";